var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 47.5 47.5",
    viewBox: "0 0 47.5 47.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,38 38,38 38,0 0,0 0,38 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 0 47.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2a6797",
    d: "m 0,0 c -3,0 -7,-8 -7,-10 0,-3 2,-4 2,-4 l 11,0 0,10 C 6,-4 2,0 0,0",
    transform: "translate(31 15)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2a6797",
    d: "m 0,0 c 3,0 7,-8 7,-10 0,-3 -2,-4 -2,-4 l -11,0 0,10 c 0,0 4,4 6,4",
    transform: "translate(7 15)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c1694f",
    d: "M 0,0 C 0,1.104 -0.896,2 -2,2 -3.104,2 -4,1.104 -4,0 l 0,7.277 c 0.596,0.347 1,0.985 1,1.723 0,1.104 -0.896,2 -2,2 -1.104,0 -2,-0.896 -2,-2 0,1.104 -0.896,2 -2,2 -1.104,0 -2,-0.896 -2,-2 0,-0.738 0.405,-1.376 1,-1.723 L -10,0 c 0,1.104 -0.896,2 -2,2 -1.104,0 -2,-0.896 -2,-2 l -1,-11.526 0,-4.474 5,0 0,-1 6,0 0,1 5,0 0,4.474 L 0,0 Z",
    transform: "translate(26 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d79e84",
    d: "m 0,0 -1,12 c 0,1.104 -0.896,2 -2,2 -1.104,0 -2,-0.896 -2,-2 l 0,-20 c 0,-6 6,-9 6,-9 0,0 6,4 6,9 L 0,0 Z",
    transform: "translate(25 21)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d79e84",
    d: "m 0,0 c -1.104,0 -2,-0.896 -2,-2 l -1,-12 -7,-8 c 0,-5 6,-9 6,-9 0,0 6,3 6,9 L 2,-2 C 2,-0.896 1.104,0 0,0",
    transform: "translate(16 35)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdcb58",
    d: "M 0,0 -6,3 -7,1 -1,-1 0,0 Z",
    transform: "translate(12 30)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdcb58",
    d: "M 0,0 6,3 7,1 1,-1 0,0 Z",
    transform: "translate(26 30)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdcb58",
    d: "m 0,0 -6,1 -1,-2 7,0 0,1 z",
    transform: "translate(10 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdcb58",
    d: "M 0,0 6,1 7,-1 0,-1 0,0 Z",
    transform: "translate(28 26)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsk);
export default __webpack_public_path__ + "static/media/ask.7571a37d0f158b308404dd2e0be28f61.svg";
export { ForwardRef as ReactComponent };